import React from 'react'
import {store} from '../../stores/store'
import {observer} from 'mobx-react'




const Action = observer(({categ}) => {
  function onSelect(categName, aepId) {
    store.setSelectedAep(categName, aepId)
  }


  let selChoiceId = store.selectedActions[categ.name]
  let prevChoiceId = store.getPrevSelectedAepId(categ.name)

  let aeps = categ.aeps.map(aep => {
    let isSel = aep.id===selChoiceId
    let wasSel = aep.id===prevChoiceId
    return (
      <div key={aep.id}>
        <label title={aep.description} className={isSel ? "selected" : wasSel ? "prevSelected" : ""}>
          <input
            type="radio"
            value={aep.id}
            name={categ.name}
            defaultChecked={isSel}
            onChange={onSelect.bind(null, categ.name, aep.id)}
            />
            <span className="aep-id">{aep.id}</span>

           {aep.name}
        </label>
      </div>)
  })

  return (
    <div className="action" >
      <h4>{categ.name}</h4>
      {aeps}
    </div>
  )
})



const Actions = ({data, onSelectChange}) => {
  return (
    <div className="actions">
      <h2>Actions</h2>
        {data.map( a => {
          return <Action key={a.name} categ={a} />
        })}
    </div>
  )
}

export default Actions